import React, { useEffect, useState } from "react";
import { Chart as ChartJS, defaults } from "chart.js/auto";
import "./state.scss";
import LineStatistique from "./Line/LineStatistique";
import BarStatistique from "./Bar/BarStatistique";
import DoughnutStatistique from "./Doughnut/DoughnutStatistique";
import * as donService from "../../services/DonService";

defaults.maintainAspectRatio = false;
defaults.responsive = true;

defaults.plugins.title.display = true;
defaults.plugins.title.align = "start";
defaults.plugins.title.font.size = 20;
defaults.plugins.title.color = "black";

export const Statistique = () => {
  const [don, setDon] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    donService
      .getAllDon()
      .then((don) => {
        setDon(don);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Erreur lors du chargement des données Teny Zaraina :",
          error
        );
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="state">
      <div className="dataCard revenueCard">
        <LineStatistique don={don} />
      </div>

      <div className="dataCard customerCard">
        <BarStatistique />
      </div>

      <div className="dataCard categoryCard">
        <DoughnutStatistique />
      </div>
    </div>
  );
};
